import ReactLoading from "react-loading";
import {
  useLikeWatchLater,
  useAuth,
  usePlaylist,
  useHistory,
  useVideo,
} from "../../context";
import "./loading.css";

export const Loading = () => {
  const { likeApiCallLoading, watchLaterApiCallLoading } = useLikeWatchLater();
  const { isLoading } = useAuth();
  const { playlistLoading, playlistVideoLoading } = usePlaylist();
  const { watchHistoryApiCallLoading } = useHistory();
  const { postVideoDataLoading, deleteVideoFromDBLoading , videoLoading} = useVideo();

  if (
    !likeApiCallLoading &&
    !watchLaterApiCallLoading &&
    !isLoading &&
    !playlistLoading &&
    !playlistVideoLoading &&
    !watchHistoryApiCallLoading &&
    !postVideoDataLoading &&
    !deleteVideoFromDBLoading &&
    !videoLoading
  )
    return null;
  return (
    <div className="loading-wrapper">
      {likeApiCallLoading && (
        <ReactLoading
          className="reacting-loading"
          type={"bars"}
          color={"#ffa500"}
        />
      )}
      {watchLaterApiCallLoading && (
        <ReactLoading
          className="reacting-loading"
          type={"bars"}
          color={"#ffa500"}
        />
      )}
      {isLoading && (
        <ReactLoading
          className="reacting-loading"
          type={"bars"}
          color={"#ffa500"}
        />
      )}
      {playlistLoading && (
        <ReactLoading
          className="reacting-loading"
          type={"bars"}
          color={"#ffa500"}
        />
      )}
      {playlistVideoLoading && (
        <ReactLoading
          className="reacting-loading"
          type={"bars"}
          color={"#ffa500"}
        />
      )}
      {watchHistoryApiCallLoading && (
        <ReactLoading
          className="reacting-loading"
          type={"bars"}
          color={"#ffa500"}
        />
      )}
      {postVideoDataLoading && (
        <ReactLoading
          className="reacting-loading"
          type={"bars"}
          color={"#ffa500"}
        />
      )}
      {deleteVideoFromDBLoading && (
        <ReactLoading
          className="reacting-loading"
          type={"bars"}
          color={"#ffa500"}
        />
      )}
      {videoLoading && <ReactLoading
          className="reacting-loading"
          type={"bars"}
          color={"#ffa500"}
        />}
    </div>
  );
};
